import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetCoopListResponse = {
  CoopCode: string;
  CoopName: string;
  PlanCoopName: string;
  CoopShortName: string;
}[];

/**
 * 会員生協情報リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetCoopListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCoopListService extends PlessJsonResponderSub<GetCoopListResponse> {
  private storeObj: object; // 格納先オブジェクト
  private storeParam: string; // 格納先属性名
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param obj 格納先オブジェクト
   * @param param 格納先属性名
   * @param s コールバック
   * @param f コールバック
   * @memberof GetCoopListService
   */
  execute(
    obj: object,
    param: string,
    s: () => void = null,
    f: () => void = null
  ) {
    this.storeObj = obj;
    this.storeParam = param;
    this.succeed = s;
    this.fail = f;
    this.send('KYMW02getCoopList', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCoopListService
   */
  success(data: GetCoopListResponse) {
    if (this.storeParam in this.storeObj) this.storeObj[this.storeParam] = data;
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param obj
   * @param param
   * @returns Promise<GetCodeListResponse>
   */
  public executeAsync(obj: object, param: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        obj,
        param,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
